module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/assets/icon/font-awesome/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/assets/icon/font-awesome/fonts/fontawesome-webfont.eot
// module chunks = styles